import CustomerHeaderInfo from 'modules/customer/components/Header/CustomerHeaderInfo';
import ProfileDropdown from 'modules/customer/components/Header/Sections/ProfileDropdown';
import { Suspense, useState } from 'react';
import { Col, Row } from 'react-bootstrap';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { customerProfileMain, customerProfileRoutes } from 'routes/customer/CustomerRoutes';
import ProtectedCustomerRoute from 'routes/customer/ProtectedCustomerRoute';
import { userProfileInfoSelector } from 'store/auth/selectors/authSelectors';
import { useAppSelector } from 'store/hooks';
import 'modules/customer/assets/scss/customerProfile.scss';
export default function CustomerProfileLayout() {
  const location = useLocation();
  const userProfileInfo = useAppSelector(userProfileInfoSelector);
  const [layoutSection, setLayoutSection] = useState<any>(null);

  const [isCollapsed, setIsCollapsed] = useState(() => {
    return localStorage.getItem('profile-sidebar-collapsed') === 'true';
  });

  const toggleCollapse = () => {
    setIsCollapsed((prev) => {
      const next = !prev;
      localStorage.setItem('profile-sidebar-collapsed', String(next));
      return next;
    });
  };

  // Redirect base /profile path to /profile/general-information
  if (
    location.pathname === customerProfileMain.path ||
    location.pathname === `${customerProfileMain.path}/`
  ) {
    return <Navigate to={customerProfileRoutes.profileGeneralInfo.path} replace />;
  }

  return (
    <ProtectedCustomerRoute>
      <div
        className={`p-4 customer-profile-layout container ${isCollapsed ? 'sidebar-collapsed' : ''}`}
      >
        <CustomerHeaderInfo />
        {userProfileInfo && (
          <Row className="g-3 align-items-start flex-nowrap">
            <Col
              xs="auto"
              className={`customer-profile-sidebar-col ${isCollapsed ? 'collapsed' : ''}`}
            >
              <ProfileDropdown
                isSidebar={true}
                isCollapsed={isCollapsed}
                onToggleCollapse={toggleCollapse}
              />
            </Col>
            <Col xs={true} className="customer-profile-main">
              {layoutSection || <div id="layout-section-portal" className="w-100" />}
              <Suspense>
                <Outlet context={{ setLayoutSection, layoutSection, isCollapsed }} />
              </Suspense>
            </Col>
          </Row>
        )}
      </div>
    </ProtectedCustomerRoute>
  );
}
